"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageCompression = void 0;
const tslib_1 = require("tslib");
const browser_image_compression_1 = tslib_1.__importDefault(require("browser-image-compression"));
class ImageCompression {
    /**
     * Compress an image file using browser-image-compression library
     * Preserves EXIF metadata
     */
    static compressImage(file_1) {
        return tslib_1.__awaiter(this, arguments, void 0, function* (file, options = {}) {
            var _a, _b;
            const compressionOptions = {
                maxSizeMB: 10, // Max file size in MB
                maxWidthOrHeight: (_a = options.maxWidthOrHeight) !== null && _a !== void 0 ? _a : 4096, // Limit dimensions to 4096px
                useWebWorker: false,
                preserveExif: true,
                initialQuality: (_b = options.quality) !== null && _b !== void 0 ? _b : 0.95,
            };
            const compressedFile = yield (0, browser_image_compression_1.default)(file, compressionOptions);
            // Convert File to Uint8Array for upload
            const arrayBuffer = yield compressedFile.arrayBuffer();
            return new Uint8Array(arrayBuffer);
        });
    }
}
exports.ImageCompression = ImageCompression;
//# sourceMappingURL=image.compression.js.map